export default {
	// Config
	apiKey: "AIzaSyAZeZTBx5GLpZf-6fM8IMCRssuvccOQOh4",
  authDomain: "simplebrands-mytrace.firebaseapp.com",
  projectId: "simplebrands-mytrace",
  storageBucket: "simplebrands-mytrace.firebasestorage.app",
  messagingSenderId: "963807191355",
  appId: "1:963807191355:web:b996a063e9a6330a6bd71e"
};
